module.exports = __webpack_public_path__ + "static/media/04n.d8e9adfb.png";